// extracted by mini-css-extract-plugin
export default {"qrcodeParentContainer":"qrcode_qrcodeParentContainer__gxaZh","qrcodeButtonsContainer":"qrcode_qrcodeButtonsContainer__DggYR"};